module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerUrl) ? _c('div', {
    ref: "subjectSwipe",
    staticClass: "swipe-wrap"
  }, [_c('ul', {
    staticClass: "flex-default"
  }, [_vm._l((_vm.bannerUrl), function(item) {
    return _c('li', {
      key: item.url,
      staticClass: "swipe-item"
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "des ellipsis"
    }, [_vm._v(_vm._s(item.dec))])])
  }), _vm._v(" "), _vm._m(0)], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "more"
  }, [_vm._v("查"), _c('br'), _vm._v("看"), _c('br'), _vm._v("更"), _c('br'), _vm._v("多"), _c('br'), _vm._v(">")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53527c84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/com-list-swipe.vue
// module id = 853
// module chunks = 2